"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledGridLayout = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Grid = require("../Grid/Grid");
var StyledGridLayout = /*#__PURE__*/(0, _styledComponents.default)(_Grid.Grid).withConfig({
  displayName: "StyledGridLayout",
  componentId: "c11n-8-107-0__sc-12y7p8e-0"
})([""]);
exports.StyledGridLayout = StyledGridLayout;